import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    DefaultDataService,
    DefaultDataServiceConfig,
    HttpUrlGenerator
} from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../../shared/services/logging';
import {
    PayrollExportCompletedSuccessStatuses,
    PayrollExportModel,
    PayrollExportStatus
} from './payroll-export.model';
import { EfaactDataService } from '../../efaact.data-service';
import moment from 'moment';
import { ResponseStatus } from '../../../common';
import { Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import * as fromShared from '../../../shared';

export const entityName = 'PayrollExport';
@Injectable({ providedIn: 'root' })
export class PayrollExportDataService extends EfaactDataService<PayrollExportModel> {
    getAll(): Observable<PayrollExportModel[]> {
        this.log.verbose({
            type: `${this.entityName}DataService:getAll`
        });
        //TODO: ugh there must be a better way
        return DefaultDataService.prototype.getAll.call(this).pipe(
            map(resp => this.mapGetResponse(resp)),
            map((items: PayrollExportModel[]) =>
                items.map(p => this.mapItems(p))
            ),
            catchError((e, c) =>
                fromShared.Errors.handleDataServiceError(this.store, e, c)
            )
        );
    }
    mapItems(item: PayrollExportModel): PayrollExportModel {
        const resp = item
            ? {
                  ...item,
                  id: this.getPayrollExportId(item),
                  Status: {
                      StatusCode: (Object as any)
                          .values(PayrollExportCompletedSuccessStatuses)
                          .includes(item.ExportStatus)
                          ? ResponseStatus.Success
                          : ResponseStatus.Warning,
                      Message: item.ExportStatus
                  }
              }
            : ({} as any);
        this.log.verbose({
            type: `${this.entityName}DataService:mapItems`,
            item,
            resp
        });
        return resp;
    }

    getPayrollExportId(item: PayrollExportModel): string | number {
        return item?.id
            ? item.id
            : moment(item.PayPeriodEndDate).format('YYYY-MM-DD');
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
}
